import Touchable from "./Touchable";

export default Touchable;
